import { render, staticRenderFns } from "./OffersListSimilar.vue?vue&type=template&id=325d67b4&"
import script from "./OffersListSimilar.vue?vue&type=script&lang=js&"
export * from "./OffersListSimilar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports